const parallaxElements = document.querySelectorAll('[data-parallax-view]');

const DEFAULT_SPEED = 0.01;

function setParallax(element) {
  const speed =
      (parseFloat(element.getAttribute('data-parallax-view-speed')) || 0.1) / 10;
  const isHorizontal = element.hasAttribute('data-parallax-view-horizontal');

  element.style.opacity = 1;

  let ticking = false;

  function update() {
    const scrollY = window.scrollY;
    const innerHeight = window.innerHeight;
    const scroll = scrollY + innerHeight;

    const elTop = element.getBoundingClientRect().top + scrollY;
    const elBottom = elTop + element.offsetHeight;

    if (elBottom >= scrollY) {
      let newPos = 0;
      let direction = 0;

      if (innerHeight >= elTop) {
        newPos = scrollY * speed;
        direction = -1;
      } else if (scroll >= elTop) {
        newPos = (elTop - scroll) * speed;
        direction = 1;
      } else {
        ticking = false;
        return;
      }

      const value = direction * newPos;
      element.style.transform = isHorizontal
          ? `translateX(${value}px)`
          : `translateY(${value}px)`;
    }

    ticking = false;
  }

  function handleScroll() {
    if (!ticking) {
      requestAnimationFrame(update);
      ticking = true;
    }
  }

  window.addEventListener('scroll', handleScroll, { passive: true });
  update();
}

if (parallaxElements.length > 0) {
  parallaxElements.forEach((element) => setParallax(element));
}
